import axios from "axios";

const getDataJsonFile = () => {
    return axios.get(`/data/pilot.json?date=${Date.now()}`).then((res) => {
        return res.data
    });
}


export const DataService = {
    getDataJsonFile
}
